import { cn } from '@/utils/cn'
import { formatUSD } from '@vaultsfyi/common/utils'
import { ErrorIcon } from '../icons/error'
import type { AssetsBalanceGroup } from './useGroupedBalances/useGroupedBalances'

interface Props {
  assetsBalance: AssetsBalanceGroup | null | undefined
  isFallback?: boolean
  className?: string
}

export function IdleAssetsBanner({ assetsBalance, isFallback, className }: Props) {
  if (!assetsBalance) return null

  const totalBalance = assetsBalance.reduce((acc, { groupTotalBalance }) => acc + groupTotalBalance, 0)
  if (totalBalance <= 0) return null

  return (
    <div className={cn('flex items-center gap-4 rounded-2xl border bg-surface p-4', className)}>
      <ErrorIcon size={20} className="shrink-0 text-warning" />
      <div className="flex flex-col gap-0.5">
        <p className="font-medium text-heading-foreground text-sm">Idle assets detected</p>
        <p className="text-body-foreground text-xs">
          You have {formatUSD(totalBalance)} sitting idle in your wallet.{' '}
          {isFallback
            ? 'Here are trending vaults you may want to explore.'
            : 'Below are some vaults we found that match your idle assets.'}
        </p>
      </div>
    </div>
  )
}
